export default "__VITE_ASSET__Dwps34h1__"